// Aktuelle Angebote. Leeres Array = Coming soon / auf Anfrage.

export const FAHRZEUGE = [];
